import { Page } from '../../types'

const otherBenefits: Page[] = [
    {
        pageType: 'question',
        title: 'Other benefits',
        name: 'other-benefits',
        questions: [
            {
                questionType: 'instanceInput',
                title: 'Total number of instances',
                name: 'other-benefits-total-instances',
                hint: '',
                rules: {
                    required: false
                }
            },
            {
                questionType: 'costInput',
                title: 'Estimated total value',
                name: 'other-benefits-estimated-total',
                hint: '',
                rules: {
                    required: false
                }
            },    
            {
                questionType: 'textarea',
                title: 'Comments',
                name: 'other-benefits-text-comments',
                hint: 'Please ensure you do not include any personal or sensitive information',
                rules: {
                    required: false
                }
            }
        ]
    },
]
export default otherBenefits
